export const OPENAI_CONFIG = {
  apiKey: import.meta.env.VITE_OPENAI_API_KEY,
  model: 'gpt-3.5-turbo',
  endpoint: 'https://api.openai.com/v1/chat/completions',
  maxTokens: 3500,
  temperature: 0.7
};

export const CONTENT_PROMPTS = {
  ideas: `Gere 3 ideias de conteúdo criativas e envolventes para redes sociais. Para cada ideia, forneça:
1. Um título cativante
2. Uma descrição detalhada que explique o conceito
3. Hashtags relevantes (5-7 hashtags)

As ideias devem ser únicas e adequadas para engajamento nas redes sociais. Formate a resposta em JSON com a seguinte estrutura:
{
  "ideas": [
    {
      "title": "string",
      "description": "string",
      "hashtags": ["string"]
    }
  ]
}`,

  contentPlan: (answers: any) => `Crie um plano estratégico de conteúdo dinâmico e visualmente atrativo com base nas seguintes informações do usuário:

Objetivo principal: ${answers.objective}
Tipo de conteúdo: ${answers.contentType}
Conteúdo mais bem-sucedido: ${answers.bestPerforming}
Público-alvo: ${answers.targetAudience}

O plano deve incluir um calendário semanal com 4 dias de postagem (Segunda, Quarta, Sexta e Sábado), cada um com um tipo diferente de conteúdo:
- Segunda-feira: Tutorial
- Quarta-feira: Dicas Rápidas
- Sexta-feira: Conteúdo Interativo
- Sábado: Behind the Scenes

Para cada dia, forneça:
1. 🔍 Objetivo do Dia - baseado no objetivo principal do usuário
2. 🎬 O que fazer - uma lista de tarefas com emojis e pontos, não texto corrido
3. 🎵 Música sugerida - uma recomendação de trilha sonora adequada
4. 🖋️ Legenda pronta - com emojis e call to action
5. 📢 CTA envolvente - uma chamada para ação específica
6. 🏷️ Hashtags - 5-8 hashtags relevantes

IMPORTANTE: 
- Todo o conteúdo deve ser ALTAMENTE PERSONALIZADO com base nas respostas do usuário
- Use MUITOS EMOJIS e LISTAS DE PONTOS em vez de parágrafos longos
- Para a seção "O que fazer", use formato de lista com ✅ no início de cada item
- Seja CONCISO e DIRETO, evitando textos longos
- Use diretamente as palavras-chave e temas mencionados pelo usuário em suas respostas

O plano deve seguir EXATAMENTE a estrutura HTML abaixo, mantendo todas as classes CSS e formatação:

<div class="plan-content">
<h1>Plano Estratégico de Conteúdo</h1>

<h2>1. Objetivo Principal</h2>
<p>[Objetivo do usuário]</p>

<h2>2. Público-Alvo</h2>
<p>[Público-alvo do usuário]</p>

<h2>3. Tipo de Conteúdo Principal</h2>
<p>[Tipo de conteúdo do usuário] com foco em [conteúdo mais bem-sucedido]</p>

<h2>4. Calendário Semanal</h2>

<div class="day-header">Segunda-feira: Tutorial</div>
<div class="task-label">🔍 Objetivo do Dia</div>
<p>[Objetivo personalizado baseado nas respostas]</p>
<div class="task-label">🎬 O que fazer</div>
<p>[Lista de tarefas com emojis ✅ no início de cada item]</p>
<div class="task-label">🎵 Música sugerida</div>
<p>[Sugestão de música com emoji 🎵]</p>
<div class="task-label">🖋️ Legenda pronta</div>
<p>[Legenda com muitos emojis]</p>
<div class="task-label">📢 CTA envolvente</div>
<p>[Call-to-action específico com emoji]</p>
<div class="task-label">🏷️ Hashtags</div>
<p class="hashtags">[Hashtags relevantes]</p>

[Repita o mesmo formato para os outros dias da semana]

<h2>5. Dicas de Engajamento</h2>
<ul>
  <li>📱 Stories: Use Stories diariamente para manter conexão com seu público</li>
  <li>💬 Interação: Responda comentários em até 2 horas após a publicação</li>
  <li>🔄 Consistência: Mantenha os horários de postagem regulares</li>
  <li>🎥 Qualidade: Invista em boa iluminação e áudio claro</li>
  <li>🌊 Tendências: Adapte trends do momento ao seu nicho</li>
</ul>

<h2>6. Estratégia de Hashtags</h2>
<ul>
  <li>📌 Populares: Use 3-5 hashtags populares do seu nicho</li>
  <li>🎯 Exclusivas: Crie hashtags próprias para suas séries de conteúdo</li>
  <li>📍 Localização: Inclua hashtags regionais relevantes</li>
  <li>🔥 Trending: Pesquise e use 2-3 hashtags em alta por post</li>
</ul>

<h2>7. Métricas a Acompanhar</h2>
<ul>
  <li>📈 Taxa de engajamento por post</li>
  <li>👥 Crescimento semanal de seguidores</li>
  <li>⏱️ Tempo médio de visualização</li>
  <li>🕒 Horários de maior interação</li>
  <li>🏷️ Performance das hashtags</li>
</ul>
</div>

LEMBRE-SE: Todo o conteúdo deve ser DIRETAMENTE relacionado às respostas do usuário. Use as palavras-chave exatas que o usuário forneceu em suas respostas para criar um plano verdadeiramente personalizado.`
};